import React from "react";
var ONE_HUNDRED_PERCENT = 100;
export var Progress = function (_a) {
    var value = _a.value, title = _a.title, maxValue = _a.maxValue, _b = _a.type, type = _b === void 0 ? "light" : _b;
    var valuePercent = value / maxValue * ONE_HUNDRED_PERCENT;
    var progressValue = Math.min(Math.max(valuePercent, 0), ONE_HUNDRED_PERCENT);
    var isCompleted = progressValue === ONE_HUNDRED_PERCENT;
    var progressStyle = isCompleted ? {} : { width: "".concat(progressValue, "%") };
    var completedClass = isCompleted ? "completed" : "";
    return (React.createElement("div", { className: "progress-linear ".concat(completedClass, " ").concat(type), role: "progressbar", "aria-valuenow": progressValue, "aria-valuemin": 0, "aria-labelledby": "progress-title", "aria-valuemax": ONE_HUNDRED_PERCENT },
        React.createElement("div", { className: "progress-linear--title", id: "progress-title" }, title),
        React.createElement("div", { className: "progress-linear--completion-container ".concat(completedClass) },
            React.createElement("div", { className: "progress-linear--completion-certificate ".concat(completedClass) },
                React.createElement("span", { className: "glyphicon-pro glyphicon-pro-verify-check" }))),
        React.createElement("div", { className: "progress-linear--background ".concat(completedClass) },
            React.createElement("div", { className: "progress-linear--bar ".concat(completedClass), style: progressStyle }))));
};
